<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    v-if="filled"
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M10.53 2.72a.75.75 0 0 0-1.06 0L5.22 6.97a.75.75 0 0 0 1.06 1.06L10 4.31l3.72 3.72a.75.75 0 1 0 1.06-1.06l-4.25-4.25Zm4.25 10.31-4.25 4.25c-.3.3-.77.3-1.06 0l-4.25-4.25a.75.75 0 1 1 1.06-1.06L10 15.69l3.72-3.72a.75.75 0 1 1 1.06 1.06Z"
    />
  </svg>
  <svg
    v-else
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M14.91 7.22a.5.5 0 0 1-.76.63L10 3.71 5.85 7.85l-.07.06a.5.5 0 0 1-.63-.76l4.5-4.5.07-.06a.5.5 0 0 1 .63.06l4.5 4.5.06.07ZM5.1 12.78a.5.5 0 0 1 .76-.63L10 16.29l4.15-4.14.07-.06a.5.5 0 0 1 .63.76l-4.5 4.5-.07.06a.5.5 0 0 1-.63-.06l-4.5-4.5-.06-.07Z"
    />
  </svg>
</template>
